/* eslint-disable no-unused-vars */
import { useMediaQuery, Box, Button, Card, Divider, Typography, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Refresh as RefreshIcon, Close as CloseIcon } from '@mui/icons-material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { RAS } from '../../../constants/organizations';
import { priceChatsNewModel, getMonthName, scaleBilling } from '../../../utils/utils';
import propTypes from 'prop-types';
import axios from 'axios';
import { actions } from '../../../actions';
import Swal from 'sweetalert2';
import { isEmpty, cloneDeep } from 'lodash';
import collections from '../../../constants/FirestoreCollections';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    billingContainer: {
      display: 'flex',
      flexDirection: small ? 'column' : 'row',
    },
    billing: {
      width: '100%',
      maxWidth: '100%',
      padding: 16,
      color: '#857979',
    },
    values: {
      width: '200px',
      maxWidth: '100%',
      padding: 16,
      marginTop: small && 16,
      color: '#857979',
    },
    title: {
      fontSize: 18,
    },
    valuesTitle: {
      fontSize: theme.sizes.sm.t2,
    },
    valueRef: {
      fontSize: theme.sizes.sm.t2,
    },
    date: {
      width: '200px',
    },
    gestionName: {
      minWidth: '200px',
    },
    gestionCount: {
      minWidth: '100px',
      flex: 1,
    },
    gestionPrice: {
      minWidth: '100px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    gestionPrepago: {
      color: '#23de4f',
    },
    footer: {
      fontSize: 12,
      marginTop: 16,
    },
    sendToEmail: {
      backgroundColor: theme.palette.randomColor2.main,
      color: theme.palette.white.main,
      '&:hover': {
        backgroundColor: theme.palette.randomColor2.light,
      },
      marginTop: small && 32,
    },
    priceBilling: {
      fontSize: theme.sizes.md.t3,
      fontWeight: 'bold',
      color: theme.palette.black.dark,
    },
    billingStatus: {
      cursor: 'pointer',
      color: theme.palette.white.main,
      fontSize: theme.sizes.sm.t1,
      borderRadius: '3rem',
      paddingInline: 16,
      display: 'flex',
      alignItems: 'center',
      transition: 'all .2s',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    billingClose: {
      backgroundColor: '#38D64D',
    },
    billingPending: {
      backgroundColor: '#4287f5',
    },
    select: {
      width: '100%',
      minHeight: 30,
      padding: '8px 16px',
      backgroundColor: 'transparent',
      outline: 'none',
      // color: theme.palette.white.main,
    },
    selectItem: {
      color: theme.palette.black.dark,
      height: '50px',
    },
    selectLabel: {
      fontSize: theme.sizes.sm.t1,
      fontWeight: 'bold',
    },
    updateKpis: {
      width: '100%',
      '&:hover': {
        background: theme.palette.primary.light,
      },
    },
    sendButton: {
      width: 30,
      height: 30,
      marginLeft: 8,
      color: 'white',
      background: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.main,
        transform: 'scale(1.1)',
      },
    },
    buttonsRef: {
      display: 'none',
      width: 'max-content',
      background: '#eee',
      padding: '2px 8px',
      position: 'absolute',
      top: '-16px',
      zIndex: 2,
    },
    pdfActions: {
      cursor: 'pointer',
      transition: 'all .2s',
      '&:hover': { transform: 'scale(1.3)' },
    },
  }));
};

function OldBill(props) {
  const { info, lastInfo } = props;
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();

  // states
  const [emailData, setEmailData] = useState();
  const [recordatorios, setRecordatorios] = useState((info && info.templatesFromGupshup) || 0);
  const [recordatoriosButton, setRecordatoriosButton] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const uploadBillRef = useRef(null);
  const uploadDataRef = useRef(null);

  // redux
  const profile = useSelector((state) => state.firebase.profile);
  const firestore = useFirestore();
  const firebase = useFirebase();
  const appDispatch = useDispatch();
  const ref = firebase.storage().ref();
  const projectId = process.env.REACT_APP_PROJECT_ID;

  // hooks
  const organization = useSelector((state) => state.app.organization);
  const organizations = useSelector((state) => state.app.organizations);

  // methods
  const setChargingModal = (boolean) => {
    return appDispatch({
      type: actions.changeLoading,
      loading: { loading: boolean, priority: 1 },
    });
  };
  const setSnackBarAlert = (message, severity) => {
    return appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: message,
        snackbarSeverity: severity,
      },
    });
  };
  const getCount = (gestion) => {
    return (gestion && info && info[gestion.replace(' ', '_')]) || 0;
  };

  // variables
  const healthSoftware =
    organization && organization.services && organization.services.healthSoftware;
  const notificationsService =
    organization && organization.services && organization.services.notifications;
  const altaService = organization && organization.services && organization.services.altaTemplate;
  const activationService =
    organization && organization.services && organization.services.activationTemplate;

  const handleSendEmail = () => {
    Swal.fire({
      title: 'Ingrese su email',
      input: 'email',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar',
    }).then((res) => {
      if (res.isConfirmed) {
        setChargingModal(true);
        firebase
          .auth()
          .currentUser.getIdToken(true)
          .then(function (token) {
            axios(`https://us-central1-${projectId}.cloudfunctions.net/emails`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
              data: {
                organizationId: organization.id,
                info: emailData,
                email: res.value,
              },
            })
              .then(() => {
                setSnackBarAlert('Email enviado correctamente', 'success');
              })
              .finally(() => {
                setChargingModal(false);
              });
          });
      }
    });
  };

  const getTime = (time) => {
    const _date = moment(time);
    const month = _date.get('month');
    const year = _date.get('year');
    const monthName = getMonthName(month);
    return `${monthName} ${year}`;
  };

  const getGupshupPrice = () => {
    if (!info || isEmpty(info)) return 0;
    const messagesFromGupshup = info && info.messagesFromGupshup;
    const messagesPrice = info && info.prices && info.prices.messages;
    const dolar = info.prices.dolar || (info && info.dolar);
    let price = 0;
    if (messagesFromGupshup * messagesPrice < 75) {
      price = messagesFromGupshup * messagesPrice * dolar;
    } else {
      price = 75 * dolar;
    }
    return price || 0;
  };

  const handleChangeStatus = () => {
    if (!isAdmin) return;
    firestore
      .collection(collections.bills)
      .where('organizationId', '==', organization.id)
      .where('date', '==', info.date)
      .get()
      .then((res) => {
        if (!res.empty) {
          const id = res.docs[0].id;
          firestore.collection(collections.bills).doc(id).update({
            isClose: !info.isClose,
          });
        }
      });
  };

  const getPriceGestiones = (gestion) => {
    if (!info || isEmpty(info)) return 0;
    const countGestiones = getCount(gestion);
    const priceByGestion = info.prices.gestiones;
    const scaleBillingEnabled =
      organization && organization.billingData && organization.billingData.scaleBilling;
    if (scaleBillingEnabled) return scaleBilling(countGestiones, priceByGestion) || 0;
    else return countGestiones * priceByGestion || 0;
  };

  // eslint-disable-next-line no-unused-vars
  /*  const updateKpis = () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    axios(`https://us-central1-${projectId}.cloudfunctions.net/billing`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        organizationId: organization.id,
        date: `${date.format('YYYY/MM')}/15`,
      },
    })
      .then(() => {
        setTimeout(() => {
          firestore
            .collection(collections.bills)
            .where('organizationId', '==', organization.id)
            .where('date', '==', info.date)
            .get()
            .then((res) => {
              if (!res.empty) {
                setInfo(res.docs[0].data());
              }
            });
        }, 1000);
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: "KPI'S actualizados correctamente",
            snackbarSeverity: 'success',
          },
        });
      })
      .catch(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: "Ocurrio un error al actualizar KPI'S",
            snackbarSeverity: 'error',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  }; */

  /*  const handleChangeFile = async (e) => {
    try {
      if (e.target.files.length > 0) {
        // appDispatch({
        //   type: actions.changeLoading,
        //   loading: { loading: true, priority: 1 },
        // });
        const file = e.target.files[0];
        const fileRes = await file.text();

        Swal.fire({
          title: 'Select field validation',
          input: 'select',
          inputOptions: {
            software: {
              macena: 'geclisa',
              ras: 'ras',
            },
          },
          inputPlaceholder: 'Seleccione el cliente',
        }).then(async (res) => {
          const orgs = [];
          if (res.value === 'macena') {
            orgs.push(
              ...organizations.filter(
                (e) =>
                  e &&
                  e.healthSoftware &&
                  e.healthSoftware.name &&
                  e.healthSoftware.name === 'macena',
              ),
            );
          } else {
            orgs.push(
              ...organizations.filter(
                (e) =>
                  e &&
                  e.healthSoftware &&
                  e.healthSoftware.name &&
                  e.healthSoftware.name === 'mrTurno5',
              ),
            );
          }
          // eslint-disable-next-line no-console

          const lastBillDate =
            info && info.date && moment(info.date).subtract(1, 'month').format('YYYY-MM');
          const result = await firestore
            .collection(collections.bills)
            .where('date', 'in', [info.date, lastBillDate])
            .get();
          const bills = [];
          result.forEach((e) => bills.push({ id: e.id, ...e.data() }));

          for (const org of orgs) {
            const line = normaliceGupshupFile(fileRes)
              .split('\n')
              .map((e) => e.split(','))
              .find((e) => e && e[0] && e[0] === org.provider.appName);
            if (line) {
              const auxInfo = bills.find(
                (e) => e.date === info.date && e.organizationId === org.id,
              );
              const messages =
                parseInt(line[1].replace('.', '')) +
                parseInt(line[3].replace('.', '')) +
                parseInt(line[4].replace('.', ''));
              const BIC = parseInt(line[6].replace('.', '')) + parseInt(line[9].replace('.', ''));
              const UIC = parseInt(line[7].replace('.', ''));
              if (organization && auxInfo) {
                await firestore.collection(collections.bills).doc(auxInfo.id).update({
                  messagesFromGupshup: messages,
                  templatesFromGupshup: BIC,
                  firstMessages: UIC,
                });
                appDispatch({
                  type: actions.changeLoading,
                  loading: { loading: false, priority: 1 },
                });
                appDispatch({
                  type: actions.alert,
                  alert: {
                    snackbarOpen: true,
                    snackbarMessage: 'Se actualizaron correctamente los precios!',
                    snackbarSeverity: 'success',
                  },
                });
                uploadDataRef.current.value = '';
              }
            }
          }
          for (const org of orgs) {
            updateTotal(org.id);
          }
          firestore
            .collection(collections.bills)
            .where('organizationId', '==', organization.id)
            .where('date', '==', info.date)
            .get()
            .then((res) => {
              if (!res.empty) {
                setInfo(res.docs[0].data());
              }
            });
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: 'Ocurrio un error, intente mast tarde :(',
          snackbarSeverity: 'error',
        },
      });
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
    }
  };
 */
  const downloadBilling = () => {
    window.open(info.billURL);
  };

  /* const deleteBilling = () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    const lastIndex = lastIndexOf(info.billURL.split(''), '/');
    let urlToRemove = info.billURL.slice(lastIndex + 1, info.billURL.indexOf('?'));
    urlToRemove = decodeURIComponent(urlToRemove);
    var desertRef = ref.child(urlToRemove);
    desertRef
      .delete()
      .then(() => {
        updateBill({ billURL: '' });
      })
      .catch(() => {})
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };
 */
  /* const updateBill = (updates) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firestore
      .collection(collections.bills)
      .where('organizationId', '==', organization.id)
      .where('date', '==', info.date)
      .get()
      .then((res) => {
        if (!res.empty) {
          const id = res.docs[0].id;
          firestore.collection(collections.bills).doc(id).update(updates);
          setInfo({
            ...info,
            ...updates,
          });
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };
 */
  /* const uploadBilling = (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];
    if (toLower(file.type).indexOf('pdf') === -1) {
      return appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Solo se aceptan archivos tipo PDF`,
          snackbarSeverity: 'error',
        },
      });
    }
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    const random = Math.floor(Math.random() * 10000);

    const route = `bills/${organization.id}/${random}-${file.name}`;
    ref
      .child(route)
      .put(file)
      .then(() => {
        ref
          .child(route)
          .getDownloadURL()
          .then((fileURL) => {
            updateBill({
              billURL: fileURL,
            });
          })
          .finally(() => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
            uploadBillRef.current.value = '';
          });
      })
      .catch(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
        uploadBillRef.current.value = '';
      });
  }; */

  const isRAS = RAS.includes(organization.id);
  const isAdmin = profile && profile.claims && profile.claims.includes('admin');
  const dolar = (info.prices && info.prices.dolar) || (info && info.dolar) || 0;

  const uicPrice =
    getCount('firstMessages') * ((info && info.prices && info.prices.firstMessages) || 0) * dolar;

  useEffect(() => {
    if (info && info.prices) {
      const extras = [];
      const prices = [
        {
          name: 'gestiones',
          value: info.prices.gestiones ? info.prices.gestiones.toFixed(2) : 0,
        },
        {
          name: 'otras gestiones',
          value: info.prices.others ? info.prices.others.toFixed(2) : 0,
        },
      ];
      if (info.prices.notifications && info.prices.notifications !== 0) {
        prices.push({
          name: 'recordatorios',
          value: info.prices.notifications ? info.prices.notifications.toFixed(2) : 0,
        });
      }
      if (info.prices.BIC && dolar) {
        prices.push({
          name: 'Plantillas Alta/Activación',
          value: (info.prices.BIC ? info.prices.BIC * dolar : 0).toFixed(2),
        });
      }
      const extrasKeys = ['business_hours_and_address', 'alta', 'cancelacion', 'consulta'];
      for (const key of extrasKeys) {
        if (info[key] && info[key] !== 0) {
          extras.push({
            name: key,
            value: info[key],
          });
        }
      }
      const recordatorios = (info && info.templatesFromGupshup) || 0;
      const _emailData = {
        ...info,
        gestiones: {
          name: 'Gestiones',
          value: getCount('gestiones'),
          price: getPriceGestiones('gestiones').toFixed(2),
        },
        others: {
          name: 'Otras gestiones',
          value: getCount('others'),
          price: (getCount('others') * (info.prices.others || 0)).toFixed(2),
        },
        recordatorios: info.notifications
          ? {
              name: 'Recordatorios',
              value: recordatorios > 0 ? recordatorios : 0,
              price: (recordatorios * (info.prices.notifications || 0)).toFixed(2),
            }
          : null,
        templates: info.otherNotifications
          ? {
              name: 'Plantillas Alta/Activación',
              value: getCount('otherNotifications'),
              price: (getCount('otherNotifications') * (info.prices.BIC || 0) * dolar).toFixed(2),
            }
          : null,
        extras,
        /* date: getMonthName(date.get('month')) + ' ' + date.get('year') || '', */
        RAS: isRAS ? ((getGupshupPrice() + uicPrice) * 0.031).toFixed(2) : 0,
        gupshup: {
          messages: {
            value: info && info.messagesFromGupshup,
            price: getGupshupPrice(),
          },
          uic: {
            value: info && info.firstMessages,
            price: uicPrice > 0 ? uicPrice : 0,
          },
        },
      };
      setEmailData(_emailData);
    }
  }, [info]);

  const isNewModel =
    organization && organization.billingData && organization.billingData.isNewModel;

  const handleSubmit = async () => {
    const objectToSend = cloneDeep(info); // copiamos el objeto de esta manera para evitar que se modifique el objeto original
    objectToSend.templatesFromGupshup = recordatorios;

    setChargingModal(true);

    try {
      const res = await axios(
        `https://us-central1-${projectId}.cloudfunctions.net/billing/update`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            organizationId: organization.id,
            date: objectToSend.date,
            info: objectToSend,
          },
        },
      );
      const newTotal = res.data.newTotal;
      info.templatesFromGupshup = recordatorios;
      info.total = newTotal;
      setRecordatoriosButton(false);
      setSnackBarAlert('Recordatorios actualizados exitosamente', 'success');
      setChargingModal(false);
    } catch (err) {
      setRecordatorios((info && info.templatesFromGupshup) || 0);
      setRecordatoriosButton(false);
      console.log(err);
      setSnackBarAlert('Ocurrio un error, intente mas tarde', 'error');
      setChargingModal(false);
    }
  };

  return (
    <Box mt={0}>
      <Box className={classes.billingContainer}>
        <Card className={classes.billing}>
          <Box display="flex" mb={2} justifyContent="space-between">
            <Typography className={classes.title}>Facturación</Typography>
            {info && !info.isClose && (
              <Box
                onClick={handleChangeStatus}
                className={`${classes.billingStatus} ${classes.billingPending}`}
              >
                Pendiente
              </Box>
            )}
            {info && info.isClose && (
              <Box
                onClick={handleChangeStatus}
                className={`${classes.billingStatus} ${classes.billingClose}`}
              >
                Cerrada
              </Box>
            )}
          </Box>
          {healthSoftware && (
            <Box>
              <Box display="flex">
                <Typography className={classes.gestionName}>GESTION</Typography>
                <Typography className={classes.gestionCount}>CANTIDAD</Typography>
                <Typography className={classes.gestionPrice}>PRECIO</Typography>
              </Box>
              <Box mb={1}>
                <Divider />
              </Box>
              {getCount('gestiones') ? (
                <Box display="flex">
                  <Typography className={classes.gestionName}>Gestiones</Typography>
                  <Typography className={classes.gestionCount}>{getCount('gestiones')}</Typography>
                  {!isNewModel && info && (
                    <Typography className={classes.gestionPrice}>
                      {'$'}
                      {getPriceGestiones('gestiones').toFixed(2)}
                    </Typography>
                  )}
                </Box>
              ) : null}
              {getCount('others') ? (
                <Box display="flex">
                  <Typography className={classes.gestionName}>Otras gestiones</Typography>
                  <Typography className={classes.gestionCount}>{getCount('others')}</Typography>
                  {!isNewModel && info && info.prices && (
                    <Typography className={classes.gestionPrice}>
                      {'$'}
                      {(getCount('others') * (info.prices.others || 0)).toFixed(2)}
                    </Typography>
                  )}
                </Box>
              ) : null}
            </Box>
          )}
          {notificationsService && recordatorios >= 0 ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Recordatorios</Typography>
              <TextField
                className={classes.gestionCount}
                value={recordatorios}
                onChange={(event) => {
                  setRecordatorios(event.target.value === '' ? 0 : parseInt(event.target.value));
                  setRecordatoriosButton(true);
                }}
                size="small"
              />
              {info && info.prices && (
                <Box marginLeft={{ xs: 5, sm: 10, md: 20, lg: 55, xl: 90 }} clone>
                  <Typography>
                    {'$'}
                    {(recordatorios * (info.prices.notifications || 0)).toFixed(2)}
                  </Typography>
                </Box>
              )}
            </Box>
          ) : null}
          {getCount('otherNotifications') && (altaService || activationService) ? (
            <Box display="flex">
              {altaService && activationService && (
                <Typography className={classes.gestionName}>Alta/Activación</Typography>
              )}
              {altaService && !activationService && (
                <Typography className={classes.gestionName}>Alta (notificación)</Typography>
              )}
              {!altaService && activationService && (
                <Typography className={classes.gestionName}>Activación (notificación)</Typography>
              )}
              <Typography className={classes.gestionCount}>
                {getCount('otherNotifications')}
              </Typography>
              {info && info.prices && (
                <Typography className={classes.gestionPrice}>
                  {'$'}
                  {(
                    getCount('otherNotifications') * (info.prices.BIC ? info.prices.BIC * dolar : 0)
                  ).toFixed(2)}
                </Typography>
              )}
            </Box>
          ) : null}
          {info && info.messagesFromGupshup ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Mensajes consumidos</Typography>
              <Typography className={classes.gestionCount}>
                {(info && info.messagesFromGupshup) || 0}
              </Typography>
              {!isNewModel && (
                <Typography className={classes.gestionPrice}>
                  {'$'}
                  {getGupshupPrice().toFixed(2)}
                </Typography>
              )}
            </Box>
          ) : null}
          {info && info.firstMessages ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>UIC</Typography>
              <Typography className={classes.gestionCount}>
                {(info && info.firstMessages) || 0}
              </Typography>
              {!isNewModel && (
                <Typography className={classes.gestionPrice}>
                  {'$'}
                  {(uicPrice > 0 ? uicPrice : 0).toFixed(2)}
                </Typography>
              )}
            </Box>
          ) : null}
          {isRAS ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>RAS</Typography>
              <Typography className={classes.gestionCount}>3.1%</Typography>
              <Typography className={classes.gestionPrice}>
                {'$'}
                {((getGupshupPrice() + uicPrice) * 0.031).toFixed(2)}
              </Typography>
            </Box>
          ) : null}
          {notificationsService ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Prepago</Typography>
              <Typography className={classes.gestionCount} />
              <Typography className={`${classes.gestionPrice} ${classes.gestionPrepago}`}>
                {'- $'}
                {((info && info.prepago && info.prepago.lastPrepago) || 0).toFixed(2)}
              </Typography>
            </Box>
          ) : null}
          {notificationsService ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Prepago siguiente</Typography>
              <Typography className={classes.gestionCount} />
              <Typography className={classes.gestionPrice}>
                {'$'}
                {(info &&
                  info.prepago &&
                  info.prepago.totalPrepago &&
                  info.prepago.totalPrepago.toFixed(2)) ||
                  0}
              </Typography>
            </Box>
          ) : null}
          {!healthSoftware ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Costo PRESTOBOTS</Typography>
              <Typography className={classes.gestionCount} />
              <Typography className={classes.gestionPrice}>${(info && info.FEE) || 0}</Typography>
            </Box>
          ) : null}
          {info && isNewModel ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Chats (whatsapp)</Typography>
              <Typography className={classes.gestionCount}>
                {(info && info.whatsapp) || 0}
              </Typography>
              <Typography className={classes.gestionPrice}>
                $
                {priceChatsNewModel(
                  info.whatsapp,
                  (info.prices && info.prices.whatsapp) || 0,
                  1.5,
                ).toFixed(2)}
              </Typography>
            </Box>
          ) : null}
          {info && isNewModel ? (
            <Box display="flex">
              <Typography className={classes.gestionName}>Chats (webchat)</Typography>
              <Typography className={classes.gestionCount}>{info.webchat || 0}</Typography>
              <Typography className={classes.gestionPrice}>
                ${(info.webchat || 0) * (info.prices.webchat || 0)}
              </Typography>
            </Box>
          ) : null}
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography className={classes.gestionName}>Total Facturación</Typography>
            <Typography className={classes.priceBilling}>
              {'$'}
              {(info && info.total && info.total.toFixed(2)) || 0}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography className={classes.footer}>
              * Los datos de esta seccion se actualizan todos los viernes, por lo que, entre dichos
              periodos puede estar viendo los datos desactualizados
            </Typography>
          </Box>
        </Card>
      </Box>

      {recordatoriosButton ? (
        <Box
          my={2}
          display="flex"
          flexDirection={small && 'column'}
          alignItems="center"
          justifyContent="center"
        >
          <Button
            startIcon={<RefreshIcon />}
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            style={{ marginRight: 5, height: '40px' }}
          >
            Actualizar Recordatorios
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setRecordatoriosButton(false);
              setRecordatorios((info && info.templatesFromGupshup) || 0);
            }}
            style={{ height: '40px' }}
          >
            <CloseIcon />
          </Button>
        </Box>
      ) : null}
    </Box>
  );
}

const Props = {
  info: propTypes.object,
  lastInfo: propTypes.object,
};

OldBill.propTypes = Props;

export default OldBill;
